/************
 * Model Class
 * File Name ...: newrequest.components.ts
 * Generated By : ianday on 12/8/23
 * Date ........: 12/8/23
 /************/
import {ValidationResult} from './validation-result';
import {DwUtils} from "../components/utils/dw-utils";

export interface NewRequest {
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    county: string;
    phoneNumber: string;
    phoneNumber2: string;
    emailAddress: string;
    caseNumber: string;
    firstName: string;
    middleName: string;
    lastName:string;
    dob: string;
    currentNeed: string;
}

export class NewRequest {
    constructor() {
        this.caseNumber = '';
        this.address1 = '';
        this.address2 = '';
        this.city = '';
        this.state = '';
        this.zipCode = '';
        this.county = '';
        this.phoneNumber = '';
        this.phoneNumber2 = '';
        this.emailAddress = '';
        this.firstName = '';
        this.middleName = '';
        this.lastName = '';
        this.dob = '';
        this.currentNeed = '';
    }

    validateRecord(): ValidationResult {
        const vr: ValidationResult = new ValidationResult();

        if(this.caseNumber.length < 6 ) {
            vr.focus_field = 'newCaseNumber';
            vr.error = 'Error: Case number must have at least six characters - click \'Generate\' to create one';
            return vr;
        }

        if (this.firstName.length === 0) {
            vr.focus_field = 'firstName';                              /* this should be the id value of the field */
            vr.error = 'Error: a firstName value is required';
            return vr;
        }

        if (this.lastName.length === 0) {
            vr.focus_field = 'lastName';                              /* this should be the id value of the field */
            vr.error = 'Error: a lastName value is required';
            return vr;
        }

        if (this.address1.length === 0) {
            vr.focus_field = 'address1';                              /* this should be the id value of the field */
            vr.error = 'Error: a address value is required';
            return vr;
        }
        if (this.city.length === 0) {
            vr.focus_field = 'city';                              /* this should be the id value of the field */
            vr.error = 'Error: a city value is required';
            return vr;
        }
        if (this.state.length === 0) {
            vr.focus_field = 'state';                              /* this should be the id value of the field */
            vr.error = 'Error: a state value is required';
            return vr;
        }
        if (this.zipCode.length !== 5) {
            vr.focus_field = 'zipCode';                              /* this should be the id value of the field */
            vr.error = 'Error: a five digit zip code is required: ';
            return vr;
        }

        if (this.dob === null) {
            vr.focus_field = 'dobId';                              /* this should be the id value of the field */
            vr.error = 'Error: a date-of-birth value is required';
            return vr;
        }
        const resp = DwUtils.chkDateOfBirth(this.dob.toString());
        if(resp.length > 0 ) {
            vr.focus_field = 'dobId';
            vr.error = resp;
            return vr;
        }
        if(this.phoneNumber.length === 0) {
            vr.focus_field = 'phoneNumber';
            vr.error = 'Error a phone number is required';
            return vr;
        }
        if(this.emailAddress.length === 0) {
            vr.focus_field = 'emailAddress';
            vr.error = 'Error an email address is required';
            return vr;
        }
        if(DwUtils.validEmailAddress(this.emailAddress) === false) {
            vr.focus_field = 'emailAddress';
            vr.error = 'Error: Invalid email address format';
            return vr;
        }

        if (this.county.length === 0) {
            vr.focus_field = 'countyId';                              /* this should be the id value of the field */
            vr.error = 'Error: a county is required';
            return vr;
        }
        return vr;
    }
}
